import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import moment from "moment/moment";
import { viewpayslip } from "../../../services/admin";
import { settinglist } from "../../../services/setting";
import serviceLogo from "../../../assets/images/logo/service_logo.png";

export default function PayslipReport() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [d, setD] = useState(null);
    const [company, setCompany] = useState({});

    useEffect(() => {
        viewpayslip(id).then((res) => {
            if (res.status === true) {
                setD(res.data.details);
            }
        });
        settinglist().then((res) => {
            if (res.status === true && res.data !== null) {
                setCompany(res.data);
            }
        });
    }, [id]);

    function fdate(v) {
        return v ? moment(v).format("DD/MM/YYYY") : "";
    }
    function amt(v) {
        return (parseFloat(v) || 0).toFixed(2);
    }

    if (d === null) {
        return (
            <div className="content-body">
                <div className="card"><div className="card-body">Loading...</div></div>
            </div>
        );
    }

    const cellLabel = { border: "1px solid #000", padding: "6px 8px", fontWeight: 600, width: "20%", verticalAlign: "top" };
    const cellValue = { border: "1px solid #000", padding: "6px 8px", width: "30%", verticalAlign: "top" };
    const th = { border: "1px solid #000", padding: "6px 8px", background: "#000", color: "#fff", textAlign: "left" };
    const td = { border: "1px solid #000", padding: "6px 8px" };
    const tdr = { border: "1px solid #000", padding: "6px 8px", textAlign: "right" };

    return (
        <div>
            <div className="page-header d-print-none">
                <h2 className="main-content-title tx-24 mg-b-5">Payslip Report</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><a>Payslip</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Payslip Report</li>
                </ol>
            </div>

            <div className="text-right mb-3 d-print-none">
                <a className="btn btn-primary me-2" onClick={() => window.print()}>Print</a>
                <a className="btn btn-secondary" onClick={() => navigate("/payslip/allpayslip")}> Back</a>
            </div>

            <style>{`
                @media print {
                    .d-print-none { display: none !important; }
                    .sidebar, .app-sidebar, .main-header, .app-header { display: none !important; }
                }
                #payslip-print { color: #000; background: #fff; }
                #payslip-print table { width: 100%; border-collapse: collapse; }
                #payslip-print .bar { background:#000; color:#fff; text-align:center; padding:8px; font-weight:700; }
            `}</style>

            <div className="content-body">
                <div className="card">
                    <div className="card-body">
                        <div id="payslip-print" style={{ maxWidth: "900px", margin: "0 auto", padding: "20px" }}>
                            {/* Company header */}
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "16px" }}>
                                <div>
                                    <img src={serviceLogo} alt="logo" style={{ maxHeight: "60px" }} />
                                </div>
                                <div style={{ textAlign: "right" }}>
                                    <div style={{ fontWeight: 700, fontSize: "16px" }}>{company.company_name || ""}</div>
                                    <div style={{ fontWeight: 600 }}>{company.company_address || ""}</div>
                                </div>
                            </div>

                            {/* Title */}
                            <div className="bar" style={{ marginBottom: "0" }}>
                                PAYSLIP FOR {(d.month || "").toUpperCase()} {d.year}
                            </div>

                            {/* Employee grid */}
                            <table style={{ marginBottom: "12px" }}>
                                <tbody>
                                    <tr>
                                        <td style={cellLabel}>Name</td><td style={cellValue}>{d.staff_name}</td>
                                        <td style={cellLabel}>PAN</td><td style={cellValue}>{d.pan}</td>
                                    </tr>
                                    <tr>
                                        <td style={cellLabel}>Code</td><td style={cellValue}>{d.staff_code}</td>
                                        <td style={cellLabel}>Sex</td><td style={cellValue}>{d.gender}</td>
                                    </tr>
                                    <tr>
                                        <td style={cellLabel}>Designation</td><td style={cellValue}>{d.designation_name}</td>
                                        <td style={cellLabel}>Account Number</td><td style={cellValue}>{d.account_number}</td>
                                    </tr>
                                    <tr>
                                        <td style={cellLabel}>Location</td><td style={cellValue}>{d.location}</td>
                                        <td style={cellLabel}>PF Account Number</td><td style={cellValue}>{d.pf_account_number}</td>
                                    </tr>
                                    <tr>
                                        <td style={cellLabel}>Joining Date</td><td style={cellValue}>{fdate(d.joining_date)}</td>
                                        <td style={cellLabel}>PF UAN</td><td style={cellValue}>{d.pf_uan}</td>
                                    </tr>
                                    <tr>
                                        <td style={cellLabel}>Leaving Date</td><td style={cellValue}>{fdate(d.leaving_date)}</td>
                                        <td style={cellLabel}>ESI Number</td><td style={cellValue}>{d.esi_number}</td>
                                    </tr>
                                    <tr>
                                        <td style={cellLabel}>Tax Regime</td><td style={cellValue}>{d.tax_regime}</td>
                                        <td style={cellLabel}></td><td style={cellValue}></td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Pay days */}
                            <table style={{ marginBottom: "12px" }}>
                                <tbody>
                                    <tr>
                                        <td className="bar" style={{ border: "1px solid #000", width: "33.33%" }}>PAY DAYS:</td>
                                        <td className="bar" style={{ border: "1px solid #000", width: "33.33%" }}>ATTENDANCE ARREAR DAYS:</td>
                                        <td className="bar" style={{ border: "1px solid #000", width: "33.33%" }}>INCREMENT ARREAR DAYS:</td>
                                    </tr>
                                    <tr>
                                        <td style={{ ...td, textAlign: "center" }}>{amt(d.pay_days)}</td>
                                        <td style={{ ...td, textAlign: "center" }}>{amt(d.attendance_arrear_days)}</td>
                                        <td style={{ ...td, textAlign: "center" }}>{amt(d.increment_arrear_days)}</td>
                                    </tr>
                                </tbody>
                            </table>

                            {/* Earnings + Deductions */}
                            <div style={{ display: "flex", gap: "12px", marginBottom: "12px" }}>
                                <div style={{ flex: 1 }}>
                                    <table>
                                        <thead>
                                            <tr><th style={th} colSpan={5} className="bar">EARNINGS (INR)</th></tr>
                                            <tr>
                                                <th style={th}>COMPONENTS</th>
                                                <th style={th}>RATE</th>
                                                <th style={th}>MONTHLY</th>
                                                <th style={th}>ARREAR</th>
                                                <th style={th}>TOTAL</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td style={td}>Basic</td>
                                                <td style={tdr}>{amt(d.basic_rate)}</td>
                                                <td style={tdr}>{amt(d.basic_monthly)}</td>
                                                <td style={tdr}>{amt(d.basic_arrear)}</td>
                                                <td style={tdr}>{amt(d.basic_total)}</td>
                                            </tr>
                                            <tr>
                                                <td style={td}>HRA</td>
                                                <td style={tdr}>{amt(d.hra_rate)}</td>
                                                <td style={tdr}>{amt(d.hra_monthly)}</td>
                                                <td style={tdr}>{amt(d.hra_arrear)}</td>
                                                <td style={tdr}>{amt(d.hra_total)}</td>
                                            </tr>
                                            <tr>
                                                <td style={td}>Advance towards statutory Bonus</td>
                                                <td style={tdr}>{amt(d.bonus_rate)}</td>
                                                <td style={tdr}>{amt(d.bonus_monthly)}</td>
                                                <td style={tdr}>{amt(d.bonus_arrear)}</td>
                                                <td style={tdr}>{amt(d.bonus_total)}</td>
                                            </tr>
                                            <tr style={{ fontWeight: 700 }}>
                                                <td style={td}>TOTAL EARNINGS</td>
                                                <td style={tdr}>{amt(d.total_earnings_rate)}</td>
                                                <td style={tdr}>{amt(d.total_earnings_monthly)}</td>
                                                <td style={tdr}>{amt(d.total_earnings_arrear)}</td>
                                                <td style={tdr}>{amt(d.gross_salary)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <table>
                                        <thead>
                                            <tr><th style={th} colSpan={2} className="bar">DEDUCTIONS (INR)</th></tr>
                                            <tr>
                                                <th style={th}>COMPONENTS</th>
                                                <th style={th}>TOTAL</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr><td style={td}>PF</td><td style={tdr}>{amt(d.pf)}</td></tr>
                                            <tr><td style={td}>ESI</td><td style={tdr}>{amt(d.esi)}</td></tr>
                                            <tr><td style={td}>PT</td><td style={tdr}>{amt(d.pt)}</td></tr>
                                            <tr style={{ fontWeight: 700 }}>
                                                <td style={td}>TOTAL DEDUCTIONS</td>
                                                <td style={tdr}>{amt(d.total_deduction)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>

                            {/* Net pay */}
                            <table style={{ marginBottom: "16px" }}>
                                <tbody>
                                    <tr>
                                        <td style={{ ...cellLabel, width: "25%" }}>NET PAY (INR)</td>
                                        <td style={{ ...td, width: "75%" }}>{amt(d.net_salary)}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ ...cellLabel, width: "25%" }}>NET PAY IN WORDS</td>
                                        <td style={{ ...td, width: "75%" }}>{d.net_in_words}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <p style={{ fontSize: "12px" }}>
                                <b>Disclaimer:</b> The above-mentioned salary slip is subject to change as and when notified by the appropriate government.
                            </p>
                            <p style={{ fontSize: "12px" }}>
                                <b>Disclaimer:</b> In the current salary slip the DA component of the wages is merged in Basic component of the wages. Kindly take note for sincere note of this interpretation.
                            </p>
                            <p style={{ textAlign: "center", color: "#666", margin: "20px 0" }}>
                                ................................................ Cut Here ................................................
                            </p>
                            <p style={{ fontSize: "12px" }}>
                                <b>Note:</b> This is a system generated payslip, does not require any signature.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
